import { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useRouter } from 'next/compat/router';
import { isNextJs } from 'tradera/utils/nextjs';
import { removePrivacySandboxIframes } from 'tradera/utils/privacy-sandbox-iframes';

export const useNavigation = (isNextDataFetchingDisabled) => {
    const nextRouter = useRouter();
    const touchwebHistory = useHistory();

    return useMemo(
        () => ({
            push: (location) => {
                removePrivacySandboxIframes();

                const url = location.pathname
                    ? `${location.pathname}${location.search}`
                    : location;
                if (isNextJs) {
                    return nextRouter.push(url, undefined, {
                        shallow: isNextDataFetchingDisabled
                    });
                }
                return touchwebHistory.push(url);
            },
            replace: (location) => {
                const url = location.pathname
                    ? `${location.pathname}${location.search}`
                    : location;
                if (isNextJs) {
                    return nextRouter.replace(url, undefined, {
                        shallow: isNextDataFetchingDisabled
                    });
                }
                return touchwebHistory.replace(url);
            },
            back: () => {
                if (isNextJs) {
                    return nextRouter.back();
                }
                return touchwebHistory.goBack();
            },
            refresh: () => {
                if (isNextJs) {
                    // Trigger fetching data from getServerSideProps().
                    return nextRouter.replace(window.location, undefined, {
                        shallow: isNextDataFetchingDisabled
                    });
                }
                throw new Error('This is only for NextWeb!');
            }
        }),
        [isNextDataFetchingDisabled, nextRouter, touchwebHistory]
    );
};
